// Supps CTA Sections - Scroll to PDP Function
function pHerbsScrollToPDP() {
  const shopSection = document.querySelector('.shop-section-container');
  if (shopSection) {
    shopSection.scrollIntoView({ behavior: 'smooth' });
  }
}
